<template>
  <v-menu
    v-model="showMenu"
    :close-on-content-click="false"
    :nudge-right="40"
    transition="scale-transition"
    offset-y
    min-width="290px"
  >
    <template v-slot:activator="{ on }">
      <v-text-field
        v-model="dateView"
        :label="label"
        :error-messages="errormessages"
        prepend-icon="mdi-calendar"
        readonly
        @click:clear="clearInput()"
        v-on="on"
      ></v-text-field>
    </template>
    <v-date-picker v-model="date" @input="handleInput" locale="locale" :first-day-of-week="1" color="primary">
      <v-btn
         text color="primary" @click="clearInput()">{{ $t('global.clear')}}
       </v-btn>
    </v-date-picker>

  </v-menu>
</template>

<script>
import { formatDateTimeSecond, formatDateTime, formatDate } from '../utils/dates';
import i18n from '../i18n.js';

export default {
  props: {
    label: {
      type: String,
      required: false,
      default: () => ''
    },
    value: String,
    errormessages: Array,
  },
  computed: {
    dateView() {
      return this.value ? formatDate(this.value) : '';
    },
    locale() {
      return i18n.locale;
    }
  },
  created() {
    this.date = this.value ? formatDate(this.value) : this.date;
  },
  data() {

    return {
      date: this.value ? formatDate(this.value) : '',
      showMenu: false
    };
  },
  methods: {
    formatDateTime,
    formatDate,
    formatDateTimeSecond,
    handleInput() {
      this.showMenu = false;
      this.$emit('input', this.date);
    },
    clearInput() {
      this.showMenu = false;
      this.date = null;
      this.$emit('input', this.date);
    }
  },

};
</script>
